/**
 * Mopper · Réalisations — modèle de données.
 *
 * AUCUN cas client fictif. Tant qu'aucune réalisation réelle suffisamment
 * documentée n'est renseignée ici, la page /realisations reste en noindex et
 * n'affiche aucune fausse page indexable.
 *
 * Modèle d'une réalisation :
 * {
 *   slug, service, city, date, context, constraints, scope,
 *   volume, distance, duration, team, result,
 *   imagesBefore: [url], imagesAfter: [url],
 *   testimonial, testimonialVerified: bool
 * }
 * Une réalisation ne devient indexable qu'avec : contexte réel + au moins une
 * image réelle + résultat documenté (règle produit interne, qualityScore >= 70).
 */
export const REALISATIONS = [];

export function getRealisation(slug) {
  return REALISATIONS.find((r) => r.slug === slug) || null;
}

export function publishedRealisations() {
  return REALISATIONS.filter(
    (r) => r.context && (r.imagesAfter || []).length > 0 && r.result
  );
}
